/**
 * Custom Element to handle UI logging
 * Listens for 'custom-uilogger' events and sends log data to the server
 */
const NODE_ENV = window.nodeEnv;
const LOCAL_DEV_UILOGGER_URL = "http://localhost:3000/ui/logger";
class CustomUILogger extends HTMLElement {
  constructor() {
    super();
    this.handleLogEvent = this.handleLogEvent.bind(this);
  }

  connectedCallback() {
    window.addEventListener("custom-uilogger", this.handleLogEvent);
  }

  disconnectedCallback() {
    window.removeEventListener("custom-uilogger", this.handleLogEvent);
  }

  async handleLogEvent(event) {
    const { level, message, meta } = event.detail;
    let loggerUrl = window.uiLoggerURL;
    console.log(
      "DEBUG: CustomUILogger: uiLoggerURL, " +
        loggerUrl +
        ", window.location.origin, " +
        window.location.origin,
    );
    // If no Url, fallback for tools like Postman, shopify theme dev
    // Settings are defined in settings_schema.json, but they only appear in settings_data.json after being set and saved in the theme editor, localhost is not allowed.
    if (!loggerUrl && NODE_ENV === "development") {
      loggerUrl = LOCAL_DEV_UILOGGER_URL;
      console.log(
        "DEBUG: CustomUILogger: uiLoggerURL not set, set uiLoggerURL, " +
          loggerUrl,
      );
    }
    try {
      await fetch(loggerUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ level, message, meta }),
      });
    } catch (error) {
      console.log("DEBUG: CustomUILogger: Failed to send log", error);
    }
  }
}

customElements.define("custom-uilogger", CustomUILogger);
